import React, { useState, useEffect } from "react";
import AboutUsBanner from "../assets/main_personal_loan_banner.webp";
import AboutUsBannerMobile from "../assets/main_personal_loan_banner_mobile.webp";
import FaQ from "./FaQ";
import "bootstrap/dist/css/bootstrap.min.css";
import checkIcon from "../assets/budget-alt.svg";
import rupeeIcon from "../assets/rupeeicon.svg";
import docIcon from "../assets/task-checklist.svg";
import coinIcon from "../assets/tax-alt.svg";
import EMICalculator from "../components/Emi";
import Applyimg from "../assets/applypersonalloan.png";
import "../App.css";

export default function PersonalLoan() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const loans = [
    {
      title: "Medical Loan",
      desc: "Unlock business funds against office/shop premises.",
      details: [
        { label: "Loan Amount", value: "₹25,000 – ₹3 Lakhs" },
        { label: "Tenure", value: "1 – 5 years" },
        { label: "Interest Rate", value: "11% p.a." },
      ],
    },
    {
      title: "Education Loan",
      desc: "Finance operations using your industrial property.",
      details: [
        { label: "Loan Amount", value: "₹1 Lakh – ₹25 Lakhs" },
        { label: "Tenure", value: "1 – 7 years" },
        { label: "Interest Rate", value: "9% p.a." },
      ],
    },
    {
      title: "Marriage Loan",
      desc: "Get a loan against assured rental income.",
      details: [
        { label: "Loan Amount", value: "₹1 Lakh – ₹50 Lakhs" },
        { label: "Tenure", value: "1 – 5 years" },
        { label: "Interest Rate", value: "10% p.a." },
      ],
    },
    {
      title: "Travel Loan",
      desc: "Borrow additional funds on your existing LAP.",
      details: [
        { label: "Loan Amount", value: "₹50,000 – ₹25 Lakhs" },
        { label: "Tenure", value: "1 – 7 years" },
        { label: "Interest Rate", value: "8.5% p.a." },
      ],
    },
    {
      title: "Small Personal Loan",
      desc: "Borrow additional funds on your existing LAP.",
      details: [
        { label: "Loan Amount", value: "₹50,000 – ₹25 Lakhs" },
        { label: "Tenure", value: "1 – 7 years" },
        { label: "Interest Rate", value: "8.5% p.a." },
      ],
    },
  ];

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const bannerImage = isMobile ? AboutUsBannerMobile : AboutUsBanner;
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://shubhpaisa.com/SeoBix/seo_injection.php?webid=524fa94a44850852fe5b6a9e70bfe6cd&url=${encodedUrl}&baseUrl=https%3A%2F%2Fshubhpaisa.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      {/* hero section */}
      <section className="w-100 position-relative">
        <div className="container-fluid p-0">
          <div
            className="position-relative w-100 d-flex hero-banner"
            style={{
              minHeight:
                windowWidth <= 768
                  ? "550px" // Mobile
                  : windowWidth <= 1024
                  ? "400px" // Tablet
                  : windowWidth <= 1600
                  ? "600px" // Medium Desktop
                  : "750px", // Large Desktop
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundImage: `url(${bannerImage})`,
              alignItems: windowWidth <= 768 ? "flex-start" : "center",
              paddingTop: windowWidth <= 768 ? "60px" : "0",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
              }}
            ></div>

            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-1"></div>
                <div
                  className="col-10"
                  style={{
                    position: "relative",
                    zIndex: 2,
                    width:
                      windowWidth <= 768
                        ? "90%"
                        : windowWidth <= 1024
                        ? "70%"
                        : "55%",
                    textAlign: windowWidth <= 768 ? "center" : "left",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: windowWidth <= 768 ? "center" : "flex-start",
                  }}
                >
                  <div className="text-start">
                    <h1
                      className="fw-semibold mb-2"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "20px"
                            : windowWidth <= 1024
                            ? "30px"
                            : "42px",
                        textAlign: "left",
                        lineHeight: "1.2",
                        fontWeight: "700",
                        color: "#2353A6",
                      }}
                    >
                      Get Instant Personal <br /> Loans with Ease
                    </h1>
                    <p
                      className="mb-4"
                      style={{
                        fontSize:
                          windowWidth <= 768
                            ? "14px"
                            : windowWidth <= 1024
                            ? "16px"
                            : "16px",
                        textAlign: "left",
                        maxWidth: "500px",
                        fontWeight: "300",
                      }}
                    >
                      Get instant funds with minimal documentation & flexible
                      EMIs.
                    </p>
                    <button
                      style={{
                        ...styles.button,
                        padding: isMobile ? "10px 20px" : "12px 28px",
                        fontSize: isMobile ? "14px" : "16px",
                        backgroundColor: "#2353A6",
                        color: "#fff",
                      }}   onClick={() => {
                        window.open("https://instantloan.shubhpaisa.com/", "_blank");
                      }}
                    >
                      Apply Now
                    </button>
                  </div>
                </div>
                <div className="col-1"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About vehicle loan */}
      <section
        className="aboutPersonalSec"
        style={{
          background:
            "linear-gradient(180deg, #cfd3f540 0%, #FFF 50%, #b3b8e940 100%)",
          padding: "80px 0",
        }}
      >
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="mb-5">About Personal Loan</h2>

            <div className="row g-4">
              <div className="col-12 col-md-6">
                <p
                  style={{
                    fontSize: ".9rem",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  A personal loan is an unsecured loan that helps you manage
                  both planned and unplanned expenses without pledging any
                  collateral such as property, gold, or other assets. It is one
                  of the most flexible forms of credit, giving you the freedom
                  to use the funds for a variety of purposes like medical
                  emergencies, higher education, weddings, home improvements,
                  small personal needs, or travel.
                </p>

                <p
                  style={{
                    fontSize: ".9rem",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  At Shubh Paisa, we understand that financial needs can arise
                  unexpectedly, and that’s why we make the process simple, fast,
                  and transparent. With minimal documentation, quick approvals,
                  and flexible repayment options, we ensure that funds are
                  available to you exactly when you need them the most.
                </p>
              </div>

              <div className="col-12 col-md-6">
                <p
                  style={{
                    fontSize: ".9rem",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  Our goal is to make borrowing stress-free by offering
                  competitive interest rates, secure processing, and
                  customer-first service, so you can focus on your priorities
                  while we take care of the financial support.
                </p>
              </div>
            </div>

            {/* CARDS */}
            <div className="row justify-content-center">
              <div className="col-12 col-md-10" style={{ maxWidth: "1100px" }}>
                <div className="row justify-content-center text-center mt-4 g-4">
                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox ">
                      <img src={checkIcon} width="40" height="40" alt="" />
                      <p>Quick approval within minutes</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox ">
                      <img src={rupeeIcon} width="50" height="50" alt="" />
                      <p>No hidden fees</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox">
                      <img src={docIcon} width="40" height="40" alt="" />
                      <p>Minimal documentation (simple KYC)</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mb-4">
                    <div className="cardBox">
                      <img src={coinIcon} width="40" height="40" alt="" />
                      <p>Balance transfer at lower rates</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Types of vehicle loans */}
      <section
        className=""
        style={{
          background: "#FFF4D1",
          padding: "80px 0",
        }}
      >
        <div className="row justify-content-center">
          <div className="col-10">
            <h2 className="text-center mb-5 " style={{ color: "#333" }}>
              Types of Personal Loan
            </h2>

            <div className="row justify-content-start">
              {loans.map((loan, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-12 mt-3">
                  <div
                    className="p-4"
                    style={{
                      background: "#fff",
                      borderRadius: "10px",
                      border: "none",
                      height: "100%",
                    }}
                  >
                    <h5 className="mb-2">{loan.title}</h5>
                    <p style={{ fontSize: "0.8rem", color: "#555" }}>
                      {loan.desc}
                    </p>

                    <div
                      className="p-2 mb-2"
                      style={{
                        border: "1px solid #E0E0E0",
                        borderRadius: "8px",
                        background: "#fff",
                      }}
                    >
                      {loan.details.map((item, i) => (
                        <p
                          key={i}
                          className="mb-1"
                          style={{ fontSize: "0.9rem", color: "#333" }}
                        >
                          <strong>{item.label}:</strong>{" "}
                          <span style={{ color: "grey" }}>{item.value}</span>
                        </p>
                      ))}
                    </div>

                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-primary"
                        style={{
                          background: "#002E94",
                          border: "none",
                          fontSize: "0.9rem",
                          padding: "6px 16px",
                        }}   onClick={() => {
                          window.open("https://instantloan.shubhpaisa.com/", "_blank");
                        }}
                      >
                        Apply Now →
                      </button>
                      {/* <button
                        className="btn btn-outline-primary"
                        style={{
                          borderColor: "#002E94",
                          color: "#002E94",
                          fontSize: "0.9rem",
                          padding: "6px 16px",
                        }}
                      >
                        Learn More
                      </button> */}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Eleglibility section */}

      <div
        className="row justify-content-center eligibility-Section"
        style={{ marginTop: "5rem", marginBottom: "4rem" }}
      >
        <div className="col-lg-10">
          <h3 className="mb-5">Eligibility & Documents Required</h3>

          <div className="row g-4">
            <div className="col-12 col-md-6">
              <p
                style={{ fontSize: ".9rem", color: "#333", lineHeight: "1.8" }}
              >
                When applying for a personal loan at Shubh Paisa, the
                eligibility conditions are kept simple to ensure that
                individuals from different backgrounds can easily access funds
                when needed. Any Indian resident aged between 21 and 60 years is
                eligible to apply. This includes salaried employees,
                self-employed professionals, business owners, and government or
                private sector workers with a stable source of income. Since
                personal loans are unsecured, no collateral is required, but
                lenders generally assess factors like credit score, income
                level, employer, and repayment history before sanctioning the
                loan.
              </p>

              <p
                style={{ fontSize: ".9rem", color: "#333", lineHeight: "1.8" }}
              >
                To complete the process, applicants are required to submit a few
                standard documents. For identity proof, one can provide Aadhaar,
                PAN, Passport, Voter ID, or Driving License. For address proof,
                documents such as Aadhaar, Passport, Driving License, recent
                utility bills (electricity, water, gas) or Ration Card are
                accepted. In addition, proof of income is mandatory — salary
                slips and bank statements for salaried applicants, or ITR and
                financial statements for self-employed individuals. Along with
                these, two recent passport-size photographs are required at the
                time of application.
              </p>
            </div>

            <div className="col-12 col-md-6">
              <p
                style={{ fontSize: ".9rem", color: "#333", lineHeight: "1.8" }}
              >
                All applications and documents are verified through secure
                systems, and once approved, the loan amount is directly
                disbursed to the vehicle dealer or seller, ensuring a quick and
                transparent process. The simplified eligibility and minimal
                documentation requirements make availing a vehicle loan fast,
                safe, and hassle-free, helping you drive home your dream
                two-wheeler, four-wheeler, or commercial vehicle with ease.
              </p>
            </div>
          </div>
        </div>
      </div>

      <EMICalculator />

      {/* How To apply */}

      <div
        style={{
          background:
            "linear-gradient(180deg, #fbf2fe 0%, #fff 50%, #FBF2FE 100%)",
          padding: "7rem 0",
          marginBottom: "1rem",
        }}
      >
        <div className="container">
          <div className="row mt-5">
            <div className="col-12">
              <div
                className="mx-auto rounded-5 overflow-visible position-relative loan-card"
                style={{
                  backgroundColor: "#CADAFF",
                  minHeight: "300px",
                  maxWidth: "1000px",
                }}
              >
                <div className="row g-0 h-100">
                  <div className="col-lg-7 col-md-6 col-12 d-flex flex-column justify-content-center p-2 p-md-3 p-lg-4">
                    <div className="banner-content mx-2">
                      <h4
                        className="text-dark fw-bold mb-3 mt-3"
                        style={{ fontSize: "clamp(18px, 2.5vw, 24px)" }}
                      >
                        How to Apply
                      </h4>
                      <p
                        className="mb-2"
                        style={{
                          color: "#6B6B6B",
                          fontSize: "clamp(14px, 1.5vw, 16px)",
                        }}
                      >
                        Apply Online / Branch Visit – Fill up the application
                        form
                      </p>
                      <p
                        className="mb-2"
                        style={{
                          color: "#6B6B6B",
                          fontSize: "clamp(14px, 1.5vw, 16px)",
                        }}
                      >
                        Submit Documents – KYC, income proof, and employment
                        proof
                      </p>
                      <p
                        className="mb-2"
                        style={{
                          color: "#6B6B6B",
                          fontSize: "clamp(14px, 1.5vw, 16px)",
                        }}
                      >
                        Verification & Credit Check – Instant CIBIL score &
                        eligibility evaluation{" "}
                      </p>
                      <p
                        className="mb-2"
                        style={{
                          color: "#6B6B6B",
                          fontSize: "clamp(14px, 1.5vw, 16px)",
                        }}
                      >
                        Approval – Get instant approval based on eligibility
                      </p>
                      <p
                        className="mb-2"
                        style={{
                          color: "#6B6B6B",
                          fontSize: "clamp(14px, 1.5vw, 16px)",
                        }}
                      >
                        Disbursal – Loan credited to your bank account within
                        24–48 hours
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-5 col-md-6 col-12 d-flex align-items-end justify-content-center position-relative">
                    <img
                      src={Applyimg}
                      alt="Service"
                      className="img-fluid position-absolute loan-img"
                      style={{
                        right: "15px",
                        bottom: "0px",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FaQ />
    </>
  );
}
const styles = {
  button: {
    border: "none",
    fontWeight: "500",
    borderRadius: "5px",
    cursor: "pointer",
  },
};
